import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import { useSnackbarContext } from 'Context/SnackbarContext';

const styles = () => ({
  root: {},
});

const ResendCodeButton = ({
  className,
  classes,
  onboardingStepResource,
}) => {
  const { displayErrorMessage, displaySuccess } = useSnackbarContext();

  // Handle resend code
  const handleResendCode = async () => {
    try {
      const resendCodeLink = onboardingStepResource
        .relationship(fr.relationships.resendCode.name)
        .link('related')
        .url();

      await fr.http.Post(resendCodeLink);
      displaySuccess('Code resent');
    } catch (err) {
      displayErrorMessage(`Failed to resend code: ${err}`);
    }
  };

  return (
    <TextButton
      className={classNames(classes.root, className)}
      onClick={handleResendCode}
      color={'primary'}
      weight={'bold'}
      fullWidth
      test={'resend-code-button'}
    >
      {'Send code again'}
    </TextButton>
  );
};

ResendCodeButton.defaultProps = {
  className: '',
};

ResendCodeButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onboardingStepResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(ResendCodeButton);
